import { SpherePlatformAppPaths } from '@sphere/platform';

export const PATHS: SpherePlatformAppPaths = {
    ['CURVE_BUILDER_PLUGIN_ID']: 'curve-builder',
    ['CB_SUMMARY_PATH']: 'summary',
    ['CB_CURVE_INSPECTOR_PATH']: 'curve',
    ['CB_NEW_PATH']: 'new',
    ['CB_CURVE_DEFINITION_VIEWER_PATH']: 'curve-definitions',
    ['CB_CURVES_PATH']: 'curves',
    ['CB_SHAPE_VIEWER_PATH']: 'shapes',
    ['CB_RULE_VIEWER_PATH']: 'rules',
    ['CB_SCRIPT_VIEWER_PATH']: 'scripts',
    ['CB_GROUP_MANAGER_PATH']: 'groups',
    ['CB_DESIGNER_PATH']: 'curve-designer',
    ['CB_DESIGNER_LANDING_PATH']: 'curve-designer-landing',
    ['CB_CURVE_VIEWER_PATH']: 'curve-viewer',
    ['CB_RULE_PACKAGES_PAGE_PATH']: 'methodologies',
    ['CB_BULK_MANAGEMENT_PAGE_PATH']: 'curves-manager',
    ['CB_CURVE_TYPE_SWAPPER_PATH']: 'convert'
};
